import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "prefix-value value-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.shouldShowPrefix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString($props.type), 1 /* TEXT */)
        ]))
        : _createCommentVNode("v-if", true);
}
